import { SeatDetail } from '@/src/types/itinerary'
import { TranslationFunction } from '@/src/types/translations'
import { getSeatType } from '@/src/utils/itinerary/addons'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { Box, Tooltip, Typography } from '@mui/material'

const SeatItem = ({
    seat,
    selectedSeatOptions,
    rowCharacteristics,
    handleAddSeat,
    handleRemoveSeat,
    getSeatColor,
    formatCurrency,
    t
}: {
    seat: SeatDetail | undefined
    selectedSeatOptions: Partial<SeatDetail>[]
    rowCharacteristics: string
    handleAddSeat: (seat: SeatDetail) => void
    handleRemoveSeat: (seat: SeatDetail) => void
    getSeatColor: (price: number) => string
    formatCurrency: (price: number) => string
    t: TranslationFunction<'itineraryPage.addons'>
}) => {
    if (seat) {
        const isSelected = selectedSeatOptions.find(selectedSeat => selectedSeat.seatNumber === seat.seatNumber)
        const { seatNumber, isAvailable, price, seatCharacteristics } = seat

        // Create tooltip content based on seat availability
        const seatType = getSeatType(seatCharacteristics)
        const tooltipTitle = isAvailable
            ? `${seatNumber} | ${seatType ? `${t(seatType)} | ` : ''} ${price === 0 ? t('Free') : formatCurrency(price)}`
            : `${seatNumber} | ${t('Booked')}`

        const seatColor = isAvailable ? getSeatColor(price) : 'seatColors.unavailable'
        // Render seat
        return (
            <Tooltip
                title={tooltipTitle}
                key={seatNumber}
                placement="top"
            >
                <Box
                    sx={{
                        width: 30,
                        height: 30,
                        bgcolor: seatColor,
                        borderRadius: 0.5,
                        cursor: isAvailable ? 'pointer' : 'not-allowed',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                        transition: 'all 0.2s ease',
                        '&:hover': isAvailable
                            ? {
                                  transform: 'scale(1.15)'
                              }
                            : {}
                    }}
                    onClick={() => {
                        if (isAvailable) {
                            if (isSelected) {
                                handleRemoveSeat(seat)
                            } else {
                                handleAddSeat(seat)
                            }
                        }
                    }}
                >
                    {isSelected && <CheckBoxIcon sx={{ fontSize: 40, color: 'success.main', background: 'white' }} />}
                    {!isAvailable && (
                        <Typography variant="caption" sx={{ color: 'white', fontSize: 12, fontWeight: 'bold' }}>
                            ✕
                        </Typography>
                    )}
                    {rowCharacteristics === 'EMERGENCY_ROW' && isAvailable && !isSelected && (
                        <Typography variant="caption" sx={{ color: 'neutral.white', fontSize: 12, fontWeight: 'bold' }}>
                            XL
                        </Typography>
                    )}
                </Box>
            </Tooltip>
        )
    } else {
        // Render empty seat (no tooltip needed for empty spaces)
        return (
            <Box
                sx={{
                    width: 30,
                    height: 30
                }}
            />
        )
    }
}

export default SeatItem
